export default "__VITE_ASSET__9aede934__"